import { Store } from 'redux';
import { EventHandler, setEventEmitter } from './eventEmitters';
import { AppActions, AppState } from '../../store/initialStateRegistration';

declare global {
    interface Window {
        mmClientApi?: Array<any> | { push: (eventName: string, params: any) => void };
        __mmClientApiSubscriptions__ ?: Map<string, any>
    }
}

type ClientAPIEventNames = 'getPageData' | 'injectArticleBlockByIndex' | 'injectVideoLogo';

export interface ClientAPIEvent {
    name: ClientAPIEventNames
    handlerCreator: (store: Store<AppState, AppActions>) => EventHandler
}

const isNewChunk = (index: number, chunkSize: number) => index % chunkSize === 0;

const getSubscribedEventsInChuncks = (items: any[], chunkSize: number) => {
    let currentChunk: any[] = [];
    return items.reduce((chunks: any[][], item, index) => {
        if (isNewChunk(index, chunkSize)) {
            currentChunk = [item];
            chunks.push(currentChunk);
        } else {
            currentChunk.push(item);
        }
        return chunks;
    }, []);
};

const handleEvent = (eventName:string, params:any) => {
    if (!window.__mmClientApiSubscriptions__) {
        window.__mmClientApiSubscriptions__ = new Map();
    }
    if (!window.__mmClientApiSubscriptions__.get(eventName)) {
        window.__mmClientApiSubscriptions__.set(eventName, []);
    }
    window.__mmClientApiSubscriptions__.get(eventName).push(params);
};

export const initClientApi = (clientAPIEvents: Array<ClientAPIEvent>, store:Store<AppState, AppActions>) => {
    if (window.mmClientApi) {
        getSubscribedEventsInChuncks((window.mmClientApi as Array<any>), 2).forEach(([eventName, params]) => handleEvent(eventName, params));
    }
    // @ts-ignore
    window.mmClientApi = {
        push: (eventName:string, params:any) => handleEvent(eventName, params),
    };
    clientAPIEvents.forEach(({ name, handlerCreator }) => setEventEmitter(name, handlerCreator(store)));
};
